import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Button,
  Chip,
  Stack,
  Grid,
  Box,
} from "@mui/material";
import moment from "moment";
import ReferenciasLaboralesForm from "./ReferenciasLaboralesForm";
import ReferenciasLaboralesEval from "./ReferenciasLaboralesEval";

const ReferenciasLaboralesItem = (props) => {
  const {
    id,
    id_candidato,
    nombre_referenciador,
    mostrarAlertaTemporal,
    evaluacion_general,
    telefono,
    puesto_y_responsabilidades,
    habilidades_y_competencias,
    motivo_salida,
    mail,
    relacion_con_candidato,
    tiempo_trabajado,
    obtenerReferencias,
    estado,
    motivo_rechazo,
  } = props;

  const [openFormModal, setOpenFormModal] = useState(false);
  const [nuevoEstado, setNuevoEstado] = useState(null);
  const [openChangeStateModal, setOpenChangeStateModal] = useState(false);

  const rrhh = localStorage.getItem("adminrrhh");

  const handleOpenFormModal = () => {
    setOpenFormModal(true);
  };

  return (
    <>
      {openFormModal && (
        <ReferenciasLaboralesForm
          isEditMode={true}
          onClose={() => setOpenFormModal(false)}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          props={props}
          obtenerReferencias={obtenerReferencias}
          id_candidato={id_candidato}
          open={openFormModal}
        />
      )}
      {openChangeStateModal && (
        <ReferenciasLaboralesEval
          id={id}
          onClose={() => {
            obtenerReferencias();
            setOpenChangeStateModal(false);
          }}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          estado={nuevoEstado}
          id_candidato={id_candidato}
          open={openChangeStateModal}
        />
      )}
      <Card
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: 2,
          borderRadius: 2,
          boxShadow: 3,
          width: 800,
          minWidth: 700,
          backgroundColor: "#ffffff",
          margin: "10px auto",
        }}
      >
        <CardContent sx={{ width: "100%" }}>
          <Grid container spacing={2}>
            {/* Columna 1 */}
            <Grid item xs={10}>
              {/* Candidato */}
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#333" }}
              >
                {nombre_referenciador}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              {/* Estado de la entrevista */}
              {rrhh === "1" && (
                <Chip
                  label={
                    estado === 1
                      ? "Aprobado"
                      : estado === 0
                      ? "Rechazado"
                      : "Pendiente"
                  }
                  color={
                    estado === 1
                      ? "success"
                      : estado === 0
                      ? "error"
                      : "default"
                  }
                />
              )}
            </Grid>
          </Grid>
          <Divider sx={{ my: 1 }} />
          {/* Info Personal */}
          <Grid container spacing={2}>
            {/* Columna 1 */}
            <Grid item xs={6}>
              <Stack spacing={1}>
                <Typography variant="body2" color="textSecondary">
                  <strong>Mail:</strong> {mail}
                </Typography>
              </Stack>
            </Grid>

            {/* Columna 2 */}
            <Grid item xs={6}>
              <Stack spacing={1}>
                <Typography variant="body2" color="textSecondary">
                  <strong>Teléfono:</strong> {telefono}
                </Typography>
              </Stack>
            </Grid>

            {/* Divider */}
            <Grid item xs={12}>
              <Divider sx={{ my: 1 }} />
            </Grid>
          </Grid>
          {/* Entrevista */}
          <Grid container spacing={2}>
            {/* Columna 1 */}
            <Grid item xs={6}>
              <Stack spacing={1}>
                <Typography variant="body2" color="textSecondary">
                  <strong>Relacion con el candidato:</strong>{" "}
                  {relacion_con_candidato}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Duracion de la relacion laboral:</strong>{" "}
                  {tiempo_trabajado}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Puesto y responsabilidad del candidato:</strong>{" "}
                  {puesto_y_responsabilidades}
                </Typography>
              </Stack>
            </Grid>

            {/* Columna 2 */}
            <Grid item xs={6}>
              <Stack spacing={1}>
                <Typography variant="body2" color="textSecondary">
                  <strong>Habilidades y competencias:</strong>{" "}
                  {habilidades_y_competencias}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Motivo de salida:</strong> {motivo_salida}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
          <Divider sx={{ my: 2 }} />
          <Grid container spacing={1}>
            <Grid item xs={10}>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ whiteSpace: "normal" }}
                display={"block"}
              >
                <strong>Evaluacion general:</strong>
                {evaluacion_general}
              </Typography>
            </Grid>
          </Grid>
          {motivo_rechazo && (
            <>
              <Divider sx={{ my: 2 }} />
              <Grid container spacing={1}>
                <Grid item xs={10}>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ whiteSpace: "normal" }}
                    display={"block"}
                  >
                    <strong sx={{ color: "red" }}>
                      Motivo de rechazo de la referencia laboral:
                    </strong>
                    {motivo_rechazo}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}

          <Divider sx={{ my: 2 }} />
          {/* Botón para editar la entrevista */}
          <Box sx={{ display: "flex", justifyContent: "end", gap: 3 }}>
            <Button
              variant="outlined"
              color={"success"}
              onClick={() => {
                setNuevoEstado(1);
                setOpenChangeStateModal(true);
              }}
              sx={{ margin: "auto 20px" }}
            >
              Arprobar referencia
            </Button>
            <Button
              variant="outlined"
              color={"error"}
              onClick={() => {
                setNuevoEstado(0);
                setOpenChangeStateModal(true);
              }}
              sx={{ margin: "auto 20px" }}
            >
              Desaprobar referencia
            </Button>
            <Button
              variant="outlined"
              color="info"
              onClick={handleOpenFormModal}
              sx={{ margin: " auto 20px " }}
            >
              Editar referencia laboral
            </Button>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default ReferenciasLaboralesItem;
